import { useShow } from "@refinedev/core";
import {
    Show,
    TextFieldComponent as TextField,
} from "@refinedev/mui";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";

export const BoardShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading } = queryResult;

    const record = data?.data;

    return (
        <Show isLoading={isLoading}>
            <Stack gap={1}>
                <Typography variant="body1" fontWeight="bold">
                    이름
                </Typography>
                <TextField value={record?.name ?? ""} />
                <Typography variant="body1" fontWeight="bold">
                    유형
                </Typography>
                <TextField value={record?.boardKind} />
                <Typography variant="body1" fontWeight="bold">
                    수정일
                </Typography>
                <TextField value={record?.updatedDate} />
                <Typography variant="body1" fontWeight="bold">
                    관련 게시글 목록
                </Typography>
                <Link to={`/posts?filters[0][field]=boardId&filters[0][operator]=eq&filters[0][value]=${record?.id}`}>바로가기</Link>
                <Typography variant="body1" fontWeight="bold">
                    첨부이미지
                </Typography>
                <Link to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=BOARD`}>바로가기</Link>
            </Stack>
        </Show>
    );
};